import { ZonedDateTime } from "@js-joda/core"
import {
  BloodGlucoseClassificationApiDto,
  BloodGlucoseClassification,
} from "./BloodGlucoseClassification"

export type BloodGlucoseReadingApiDto = {
  id: string
  patientId: string
  dateTime: string // ISO 8601 with offset, e.g. "2026-01-26T09:15:00+01:00"
  bloodGlucoseInMilligramsPerDeciliter: number
  classification: BloodGlucoseClassificationApiDto
}

export type BloodGlucoseReading = {
  id: string
  patientId: string
  dateTime: ZonedDateTime
  bloodGlucoseInMilligramsPerDeciliter: number
  classification: BloodGlucoseClassification
}

export const toBloodGlucoseReading = (dto: BloodGlucoseReadingApiDto): BloodGlucoseReading => ({
  id: dto.id,
  patientId: dto.patientId,
  dateTime: ZonedDateTime.parse(dto.dateTime),
  bloodGlucoseInMilligramsPerDeciliter: dto.bloodGlucoseInMilligramsPerDeciliter,
  classification: dto.classification,
})
